import { render, staticRenderFns } from "./button-navbar.vue?vue&type=template&id=0e0de7e9&scoped=true&"
import script from "./button-navbar.vue?vue&type=script&lang=js&"
export * from "./button-navbar.vue?vue&type=script&lang=js&"
import style0 from "./button-navbar.vue?vue&type=style&index=0&id=0e0de7e9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0de7e9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VChip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0de7e9')) {
      api.createRecord('0e0de7e9', component.options)
    } else {
      api.reload('0e0de7e9', component.options)
    }
    module.hot.accept("./button-navbar.vue?vue&type=template&id=0e0de7e9&scoped=true&", function () {
      api.rerender('0e0de7e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/button-navbar/button-navbar.vue"
export default component.exports